import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahInvoiceAccountCodes } from '~constants/api';

import { Request, Response, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

export const typePrefix = 'account-codes';

export interface AccountInvoiceCode {
  id: string;
  company_id: number;
  code: boolean;
  name: string;
  allow_supplier_invoice?: boolean | null;
  allow_supplier_reimburse?: boolean | null;
  [key: string]: any;
}

interface UpsertRequest extends Partial<AccountInvoiceCode> {
  id?: string;
}

export const accountCodesApi = createApi({
  reducerPath: 'accountCodesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahInvoiceAccountCodes }),
  tagTypes: ['accountCodes', 'accountCode'],
  endpoints: (builder) => ({
    getAccountCodes: builder.query<AccountInvoiceCode[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'accountCodes', id: 'LIST' }],
      transformResponse: (payload) => unwrap<AccountInvoiceCode[]>(payload),
    }),
    getAccountCode: builder.query<AccountInvoiceCode, { id: string }>({
      query: ({ id, ...rest }) => ({
        url: `/${id}`,
        method: 'GET',
        ...rest,
      }),
      providesTags: (_result, _error, { id }) => [{ type: 'accountCode', id }],
      transformResponse: (payload) => unwrap<AccountInvoiceCode>(payload),
    }),
    upsertAccountCode: builder.mutation<Response<AccountInvoiceCode>, UpsertRequest>({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'accountCodes', id: 'LIST' }],
      transformResponse: (payload) => payload as Response<AccountInvoiceCode>,
    }),
    deleteAccountCode: builder.mutation<Response<AccountInvoiceCode>, { id: string }>({
      query: ({ id }) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'accountCodes', id: 'LIST' }],
      transformResponse: (payload) => payload as Response<AccountInvoiceCode>,
    }),
  }),
});

export const {
  useGetAccountCodesQuery,
  useGetAccountCodeQuery,
  useUpsertAccountCodeMutation,
  useDeleteAccountCodeMutation,
} = accountCodesApi;
